import { theme } from '../../styles/_variables'

const { color } = theme

export const status = {
  ALL: 'ALL',
  AVAILABLE: 'AVAILABLE',
  REPAIRING: 'REPAIRING',
  OUT_OF_SERVICE: 'OUT_OF_SERVICE',
  WATCHING: 'WATCHING',
  ACCIDENT: 'ACCIDENT',
  NO_DRIVER: 'NO_DRIVER',
  IN_USE: 'IN_USE',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  AVAILABLE: 'พร้อมใช้งาน',
  REPAIRING: 'ซ่อมอยู่',
  OUT_OF_SERVICE: 'เลิกใช้',
  WATCHING: 'เฝ้าระวัง',
  ACCIDENT: 'อุบัติเหตุ',
  NO_DRIVER: 'ไม่มีคนขับ',
  IN_USE: 'วิ่งงานอยู่',
}

export const statusColor = {
  ALL: color.black,
  AVAILABLE: color.success,
  REPAIRING: color.warning,
  OUT_OF_SERVICE: color.error,
  WATCHING: color.warning,
  ACCIDENT: color.error,
  NO_DRIVER: color.black,
  IN_USE: color.warning,
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const ownerTypes = [
  { text: 'ทั้งหมด', value: 'ALL' },
  { text: 'ผดุงฤทธิ์', value: 'PADOONGRICH' },
  { text: 'รถร่วมในเครือ', value: 'JOINTCAR' },
  { text: 'รถร่วมนอก', value: 'OUTJOINTCAR' },
]

export const ownerTypesObj = {
  PADOONGRICH: 'PADOONGRICH',
  JOINTCAR: 'JOINTCAR',
  OUTJOINTCAR: 'OUTJOINTCAR',
  PADOONGRICH_TH: 'ผดุงฤทธิ์',
  JOINTCAR_TH: 'รถร่วมในเครือ',
  OUTJOINTCAR_TH: 'รถร่วมนอก',
}
